// extracted by mini-css-extract-plugin
export var products = "index-module--products--4eb3a";
export var threadOnCamera = "index-module--threadOnCamera--c596c";